<template>

    <div class="element nested-element blue" v-show="packageExpanded" v-bind:class="{'collapsed': !setExpanded, 'expanded': setExpanded}">
        <div class="element-heading">
            <div class="collapse-icon" @click="toggleCollapse">
                <i class="fa fa-plus" v-show="!setExpanded"></i>
                <i class="fa fa-minus" v-show="setExpanded"></i>
            </div>
            <div class="element-name">
                {{ set.display_name }}
                <small>{{ set.output_identification_name }}</small>
            </div>
            <div class="element-buttons">
                <a href="javascript:void(0);" class="text-primary edit" v-if="userHasPermission('marketing_resources.marketing_resources.edit')" @click="editSet" :title="t.__('Edytuj')"><i class="fa fa-pencil-square-o"></i></a>
                <a href="javascript:void(0);" class="text-dark translate" v-if="userHasPermission('marketing_resources.marketing_resources.edit')" @click="translateSet" :title="t.__('Tłumacz')"><i class="fa fa-language"></i></a>
                <a href="javascript:void(0);" class="text-info preview" @click="previewSet" :title="t.__('Podgląd')"><i class="fa fa-eye"></i></a>
            </div>
        </div>
        <slot :set-expanded="setExpanded"></slot>
    </div>

</template>

<script>
    export default {

        name: 'MarketingResourcesSet',

        props: [
            'set',
            'packageExpanded'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                setExpanded: false
            }
        },

        mounted() {

            this.eventHub.$on('marketing-resources-collapse-all', () => {
                this.setExpanded = false;
            });

            this.eventHub.$on('marketing-resources-expand-all', () => {
                this.setExpanded = true;
            });

        },

        methods: {

            toggleCollapse() {
                this.setExpanded = !this.setExpanded;
            },

            editSet() {
                this.eventHub.$emit('marketing-resources-edit', 'set', this.set);
            },

            translateSet() {
                this.eventHub.$emit('marketing-resources-translate', 'set', this.set);
            },

            previewSet() {
                this.eventHub.$emit('marketing-resources-preview', 'set', this.set);
            }

        }

    }
</script>

<style scoped>

</style>
